import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { shortDateFormat } from "src/app/shared/dateTimeHelpers";
import {
  QuestionType,
  Survey,
  TenantSurvey,
  SurveyAnswerModel,
  SaveResponse,
} from "src/app/shared/models/survey";
import { LookupService } from "src/app/shared/services/lookup.service";
import { NotificationService } from "src/app/shared/services/notification.service";
import { SurveyService } from "src/app/shared/services/survey.service";

@Component({
    selector: "app-survey-page",
    templateUrl: "./survey-page.component.html",
    styleUrls: ["./survey-page.component.scss"],
    standalone: false
})
export class SurveyPageComponent implements OnInit {
  administrativeUnitSurveyId: string;
  administrativeUnitSurvey: TenantSurvey;
  survey: Survey;

  dateFormat: string = shortDateFormat;

  minSortId: number = 1;
  maxSortId: number = 100;

  questionTypes: QuestionType[];
  lastEdit: Date = new Date();

  modifyQuestion$ = new Subject<SaveResponse>();

  constructor(
    private surveyService: SurveyService,
    private notificationService: NotificationService,
    private lookupService: LookupService,
    private route: ActivatedRoute
  ) {}

  async ngOnInit(): Promise<void> {
    this.administrativeUnitSurveyId = this.route.snapshot.paramMap.get("administrativeUnitSurveyId");
    this.questionTypes = await this.lookupService
      .getQuestionTypes()
      .toPromise();
    await this.load();
  }

  async load() {
    this.administrativeUnitSurvey = await this.surveyService
      .getAdministrativeUnitSurvey(this.administrativeUnitSurveyId)
      .toPromise();
    //this.survey = this.administrativeUnitSurvey.survey;
    this.survey = await this.surveyService
      .get(
        this.administrativeUnitSurvey.surveyId,
        this.administrativeUnitSurvey.survey?.language || "en",
        this.administrativeUnitSurvey.id
      )
      .toPromise();

    this.survey.answers = this.administrativeUnitSurvey.survey.answers;
  }

  async onSaveResponse(answer: SurveyAnswerModel) {
    answer.administrativeUnitSurveyId = this.administrativeUnitSurveyId;

    await this.surveyService
      .saveAnswer(answer)
      .toPromise()
      .then((saved: SurveyAnswerModel) => {
        var mod = {
          questionId: saved.questionId,
          success: true,
          errorMsg: null,
        } as SaveResponse;
        this.modifyQuestion$.next(mod);
        this.notificationService.success("Answer has been saved!");
      })
      .catch((err) => {
        var mod = {
          questionId: answer.questionId,
          success: false,
          errorMsg: "Unable to save your answer, please try again.",
        } as SaveResponse;
        this.modifyQuestion$.next(mod);
        this.notificationService.alert(
          "There was a problem saving your response. The information displayed on your screen may not be accurate. Please click 'OK' to reload the current page.",
          "Application Error",
          () => {
            //this.load();
          }
        );
      });
  }
}
